import { createSlice } from "@reduxjs/toolkit";
import { getCompanies } from "./thunk";

export interface IState {
  companies: any;
  isCompanyLoading: boolean;
  isCompanySuccess: boolean;

  error: any;
}

export const initialState: IState = {
  companies: null,
  isCompanyLoading: false,
  isCompanySuccess: false,

  error: {},
};

const CompanySlice = createSlice({
  name: "Company",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //get Companies
    builder.addCase(getCompanies.pending, (state: IState, action: any) => {
      state.isCompanyLoading = true;
    });
    builder.addCase(getCompanies.fulfilled, (state: IState, action: any) => {
      state.companies = action.payload?.data;
      state.isCompanySuccess = true;
      state.isCompanyLoading = false;
    });
    builder.addCase(getCompanies.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isCompanySuccess = false;
      state.isCompanyLoading = false;
    });
  },
});

export default CompanySlice.reducer;
